module.exports = __webpack_public_path__ + "static/media/just_married.13d942cb.svg";